<div class="grid">
    <div class="col-12">
        <p-table #maintable 
        [value]="dataList" 
        dataKey="id" 
        [columns]="cols"
        dataKey="id" 
        [rows]="10" 
        [loading]="loading" 
        [rowHover]="true" 
        styleClass="p-datatable-gridlines" 
        [paginator]="true" 
        responsiveLayout="scroll"
        (onEditComplete)="onEditComplete($event)"
        editMode="row">
        <ng-template pTemplate="caption">
            <div class="flex justify-content-between flex-column sm:flex-row">
                <div class="flex" *ngIf="nuovoLabel && nuovoLabel!=''">
                    <button pButton label="{{nuovoLabel}}" 
                        class="p-button-outlined mb-2" icon="pi pi-plus" (click)="nuovoRecord()">
                    </button>
                </div>
                <div class="flex">
                    <span class="p-input-icon-left mb-2 ml-2">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" #filter (input)="onGlobalFilter(maintable, $event)" 
                        placeholder="Ricerca ..." class="w-full"/>
                    </span>
                </div>
            </div>
        </ng-template>
        <ng-template  pTemplate="header" let-columns>
            <tr>
                    <th *ngIf="reorderable && editable">
                    </th>
                     <th *ngFor="let col of columns" 
                     [pSortableColumn]="col.field" 
                     [pSortableColumnDisabled]="col.pSortableColumnDisabled" 
                     [style]="col.style">
                        {{ col.header }} <p-sortIcon *ngIf="!col.pSortableColumnDisabled" field="col.field" />
                    </th>
               
            </tr>
        </ng-template>
        <ng-template pTemplate="body" 
            *ngIf="editable"
            let-record
            let-columns="columns" 
            let-editing="editing" 
            let-index="rowIndex"> 
            <tr [pReorderableRow]="index" [pEditableRow]="record">
                <td *ngIf="reorderable">
                    <span class="pi pi-bars" pReorderableRowHandle></span>
                </td>
                <td *ngFor="let col of columns" pEditableColumn>
                    <p-cellEditor *ngIf="col.type=='field'" >
                        <ng-template pTemplate="input">
                            <input pInputText type="text" [(ngModel)]="record[col.field]">
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{record[col.field] }}
                        </ng-template>
                    </p-cellEditor>
                    <p-cellEditor *ngIf="col.type=='currency'" >
                        <ng-template pTemplate="input">
                            <p-inputNumber  [(ngModel)]="record[col.field]"></p-inputNumber>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{record[col.field] |currency:'EUR':'symbol' }}
                        </ng-template>
                    </p-cellEditor>
                    <p-cellEditor *ngIf="col.type=='perc'" >
                        <ng-template pTemplate="input">
                            <p-inputNumber  [(ngModel)]="record[col.field]"></p-inputNumber>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{record[col.field]}} %
                        </ng-template>
                    </p-cellEditor>
                    <p-cellEditor *ngIf="col.type=='number'" >
                        <ng-template pTemplate="input">
                            <p-inputNumber  [(ngModel)]="record[col.field]"></p-inputNumber>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{record[col.field]}} 
                        </ng-template>
                    </p-cellEditor>
                    <p-cellEditor *ngIf="col.type=='date'">
                            <ng-template pTemplate="input">
                                <p-calendar appendTo="body" dateFormat="dd/mm/yy" [(ngModel)]="record[col.field]"></p-calendar>
                             </ng-template>
                            <ng-template pTemplate="output">
                                {{ record[col.field] | date: 'dd/MM/yyyy' }}
                            </ng-template>
                    </p-cellEditor>
                    <p-cellEditor *ngIf="col.type=='check'">
                        <ng-template pTemplate="input">
                            <p-checkbox name="record[col.field]"  
                            [(ngModel)]="record[col.field]" styleClass="mr-2" [binary]="true"></p-checkbox>
                        </ng-template>
                        <ng-template pTemplate="output">
                            <div class="text-center">
                                <i class="pi" [ngClass]="{'true-icon pi-check-circle text-green-500': record[col.field], 'false-icon pi-times-circle text-pink-500': !record[col.field]}"></i>
                            </div>
                        </ng-template>
                    </p-cellEditor>
                  
                    <p-cellEditor *ngIf="col.type=='select'">
                        <ng-template pTemplate="input">
                            <p-dropdown [options]="col.options" appendTo="body" [(ngModel)]="record[col.field]" 
                            [style]="{'width':'100%'}"></p-dropdown>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{getLabel(col.field,record[col.field])}}
                        </ng-template>
                    </p-cellEditor>
                    <p-cellEditor *ngIf="col.type=='textarea'">
                        <ng-template pTemplate="input">
                            <textarea pinputtextarea class="p-inputtextarea p-inputtext" rows="2" cols="50" 
                            [(ngModel)]="record[col.field]"></textarea>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{record[col.field]}}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <td style="text-align:center">
                    <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onRowEditInit(record)" class="p-button-rounded p-button-text"></button>
                    <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" (click)="onRowEditSave(record)" class="p-button-rounded p-button-text p-button-success p-mr-2"></button>
                    <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onRowEditCancel(record, index)" class="p-button-rounded p-button-text p-button-danger"></button>
                    <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow icon="pi pi-trash" (click)="deleteRecord(record)" class="p-button-rounded p-button-text"></button>
    
                </td>
            </tr>

        </ng-template>   
        <ng-template 
            *ngIf="!editable"
            pTemplate="body" let-rowData let-columns="columns">
            <tr>
                <td *ngFor="let col of columns">
                    <div *ngIf="col.type=='edit'" class="flex">
                        <button pButton pRipple icon="pi pi-pencil" 
                        class="p-button-rounded p-button-text" (click)="edit(rowData)"></button>
                    </div>
                    <div *ngIf="col.type=='settings'" class="flex">
                        <button pButton pRipple icon="pi pi-wrench" 
                        class="p-button-rounded p-button-text" (click)="settings(rowData)"></button>
                    </div>
                    <div *ngIf="col.type=='field'" [style]="col.style">
                        {{ rowData[col.field] }}
                    </div>
                    <div *ngIf="col.type=='currency'" [style]="col.style">
                        {{rowData[col.field] |currency:'EUR':'symbol' }}
                    </div>
                    
                    <div *ngIf="col.type=='date'" [style]="col.style">
                        {{ rowData[col.field] | date: 'dd/MM/yyyy' }}
                    </div>
                    
                    <div *ngIf="col.type=='check'" class="text-center">
                        <i class="pi" [ngClass]="{'true-icon pi-check-circle text-green-500': rowData[col.field], 'false-icon pi-times-circle text-pink-500': !rowData[col.field]}"></i>
                    </div>
                    <div *ngIf="col.type=='delete'" class="flex">
                        <button pButton pRipple icon="pi pi-trash" 
                        class="p-button-rounded p-button-text" (click)="delete(rowData)"></button>
                    </div>
                </td>
            </tr>
        </ng-template> 
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="8">Nessun record presente</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="loadingbody">
            <tr>
                <td colspan="8">Caricamento in corso ...</td>
            </tr>
        </ng-template>
    </p-table>
    </div>
</div>